module.exports = __webpack_public_path__ + "static/media/image-modal.a85bb840.png";